import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-mira-bg border-t border-mira-border pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-1">
             <Link to="/" className="flex items-center space-x-2 mb-4">
               <Logo className="w-6 h-6 text-mira-accent" />
               <span className="text-xl font-bold text-white tracking-wide">
                 Mira<span className="text-mira-accent">-IA</span>
               </span>
             </Link>
             <p className="text-gray-400 text-sm leading-relaxed">
               Automatizamos tu negocio con tecnología de vanguardia. Chatbots, integraciones y flujos inteligentes.
             </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Explorar</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/" className="hover:text-mira-accent transition-colors">Home</Link></li>
              <li><Link to="/servicios" className="hover:text-mira-accent transition-colors">Servicios</Link></li>
              <li><Link to="/proyectos" className="hover:text-mira-accent transition-colors">Proyectos</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Compañía</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/sobre-nosotros" className="hover:text-mira-accent transition-colors">Sobre Nosotros</Link></li>
              <li><Link to="/contacto" className="hover:text-mira-accent transition-colors">Contacto</Link></li>
              <li><Link to="/aviso-de-privacidad" className="hover:text-mira-accent transition-colors">Privacidad</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Síguenos</h3>
            <div className="flex flex-col space-y-4">
              <a 
                href="https://www.instagram.com/mira.automation?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-mira-accent transition-all group w-fit"
              >
                <div className="p-2 bg-mira-surface rounded-full group-hover:bg-mira-accent/10 border border-transparent group-hover:border-mira-accent transition-all">
                  <Instagram className="w-5 h-5" />
                </div>
                <span className="font-medium text-sm">@mira.automation</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-mira-border pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Mira-IA. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm text-gray-500">
            <Link to="/aviso-de-privacidad" className="hover:text-white transition-colors">Términos</Link>
            <Link to="/aviso-de-privacidad" className="hover:text-white transition-colors">Privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;